export default "/fonts/iconly.woff2?03fd9c78befedfe11bb6f64663f9a28c";